import React, { useEffect, useRef, useState } from 'react'
import smoothscroll from 'smoothscroll-polyfill'
import styles from './styles.module.scss'
import WeInMediaFull from './WeInMediaFull/WeInMediaFull'

const Media = ({ checkDomenNameState, ourRef }) => {
  smoothscroll.polyfill()
  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])
  return (
    <div>
      <div className={styles.wrapper} id="content">
        <div>
          <WeInMediaFull checkDomenNameState={checkDomenNameState} ourRef={ourRef} />
        </div>
      </div>
    </div>
  )
}

export default Media
